<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import AssignmentPropertyCell from "./_modules/assignment-property-cell"
  import type { AssignWorkOrderDraft, WorkOrderAssignmentRow } from "../../contract"

  let props: InboxWorkflowCellProps = $props()

  const row = $derived(props.row as unknown as WorkOrderAssignmentRow)
  const draft = $derived(props.draft as AssignWorkOrderDraft)
</script>

<AssignmentPropertyCell {row} {draft} />
